<template>
  <div class="mt-3 mb-3">
    <p>Email-Vorlagen</p>
    <div>
      <!-- Load dropdown + save row -->
      <div class="row g-2 mb-2">
        <div class="col-auto">
          <select class="form-select form-select-sm" v-model="selectedTemplateId" @change="onTemplateSelect">
            <option :value="null">-- Vorlage laden --</option>
            <option v-for="t in templateStore.sortedData" :key="t.id" :value="t.id">
              {{ t.name }}
            </option>
          </select>
        </div>
        <div class="col">
          <div class="input-group input-group-sm">
            <input v-model="newName" class="form-control" placeholder="Neuer Vorlagen-Name">
            <button class="btn btn-outline-primary" @click="saveTemplate" :disabled="!newName.trim()">
              Neu
            </button>
          </div>
        </div>
      </div>

      <!-- Edit name + delete row (shown when a template is selected) -->
      <div v-if="selectedTemplate" class="d-flex gap-2 align-items-center mb-2">
        <input v-model="editingName" class="form-control form-control-sm" style="max-width: 250px" placeholder="Neuer Name">
        <button class="btn btn-sm btn-outline-secondary" @click="saveName">Speichern</button>
        <button class="btn btn-sm btn-outline-danger" @click="deleteTemplate">Entfernen</button>
      </div>
    </div>
  </div>
</template>

<script>
import { useEmailTemplateStore } from '@/stores/emailTemplate';

export default {
  name: 'EmailTemplateSelector',
  props: {
    subject: { type: String, required: true },
    message: { type: String, required: true }
  },
  data() {
    return {
      selectedTemplateId: null,
      newName: '',
      editingName: ''
    };
  },
  watch: {
    subject() { this.$emit('update:message', this.message); },
    message() { this.$emit('update:subject', this.subject); }
  },
  setup() {
    const templateStore = useEmailTemplateStore();
    return { templateStore };
  },
  created() {
    if (!this.templateStore.loadedData) {
      this.templateStore.getData();
    }
  },
  methods: {
    onTemplateSelect() {
      const template = this.templateStore.getItemById(this.selectedTemplateId);
      if (template) {
        this.$emit('update:subject', template.subject);
        this.$emit('update:message', template.message);
        this.editingName = template.name;
      }
    },
    async saveTemplate() {
      try {
        await this.templateStore.addItem({
          name: this.newName.trim(),
          subject: this.subject,
          message: this.message
        });
        this.newName = '';
        this.$emit('toast', { ok: true, message: 'Vorlage gespeichert.' });
      } catch (e) {
        this.$emit('toast', { ok: false, message: 'Fehler beim Speichern der Vorlage.' });
      }
    },
    async saveName() {
      const template = this.templateStore.getItemById(this.selectedTemplateId);
      if (!template) return;
      try {
        await this.templateStore.updateItem({
          ...template,
          name: this.editingName.trim(),
          subject: this.subject,
          message: this.message
        });
        this.$emit('toast', { ok: true, message: 'Vorlage aktualisiert.' });
      } catch (e) {
        this.$emit('toast', { ok: false, message: 'Fehler beim Aktualisieren der Vorlage.' });
      }
    },
    async deleteTemplate() {
      const template = this.templateStore.getItemById(this.selectedTemplateId);
      if (!template) return;
      try {
        await this.templateStore.deleteItem(template, false, 'Vorlage');
        this.selectedTemplateId = null;
        this.editingName = '';
        this.$emit('toast', { ok: true, message: 'Vorlage gelöscht.' });
      } catch (e) {
        this.$emit('toast', { ok: false, message: 'Fehler beim Löschen der Vorlage.' });
      }
    }
  },
  computed: {
    selectedTemplate() {
      if (!this.selectedTemplateId) return null;
      return this.templateStore.getItemById(this.selectedTemplateId);
    }
  }
};
</script>
